import {
  Boxes,
  Building2,
  CalendarRange,
  CreditCard,
  FileSpreadsheet,
  Fingerprint,
  HandCoins,
  Landmark,
  ClipboardList,
  Palmtree,
  Scissors,
  ScrollText,
  SlidersHorizontal,
  Tag,
  Truck,
  Wallet,
  UserCog,
  Receipt,
} from 'lucide-react';
import type { SeccionModulo } from './navegacion';

/** Secciones (submenú lateral) de cada módulo. Se amplía conforme se agregan pantallas. */
export const SECCIONES_POR_MODULO: Record<string, SeccionModulo[]> = {
  configuracion: [
    { to: '/configuracion', etiqueta: 'General', icono: SlidersHorizontal, permisos: ['config.ver'], palabrasClave: 'ajustes preferencias' },
    { to: '/configuracion/servicios', etiqueta: 'Servicios', icono: Scissors, permisos: ['config.ver'], palabrasClave: 'precios duración comisión catálogo' },
    { to: '/configuracion/usuarios', etiqueta: 'Usuarios y permisos', icono: UserCog, permisos: ['usuarios.gestionar'], palabrasClave: 'alta baja accesos contraseña' },
    { to: '/configuracion/sucursal', etiqueta: 'Sucursal', icono: Building2, permisos: ['config.ver'], palabrasClave: 'horario estaciones dirección' },
    { to: '/configuracion/mercadopago', etiqueta: 'Mercado Pago', icono: CreditCard, permisos: ['config.mercadopago'], palabrasClave: 'tarjeta terminal point cobro' },
    { to: '/configuracion/auditoria', etiqueta: 'Bitácora', icono: ScrollText, permisos: ['auditoria.ver'], palabrasClave: 'auditoría registro actividad' },
  ],
};

export const SECCIONES_PERSONAL: SeccionModulo[] = [
  { to: '/personal', etiqueta: 'Horarios', icono: CalendarRange, permisos: ['personal.ver'], palabrasClave: 'turnos semana descanso' },
  { to: '/personal/vacaciones', etiqueta: 'Vacaciones', icono: Palmtree, palabrasClave: 'permisos días libres' },
  { to: '/personal/asistencia', etiqueta: 'Asistencia', icono: Fingerprint, palabrasClave: 'checador llegada salida retardos faltas' },
  { to: '/personal/nomina', etiqueta: 'Pago semanal', icono: HandCoins, permisos: ['nomina.ver'], palabrasClave: 'nómina sueldo comisiones propinas' },
];

SECCIONES_POR_MODULO.caja = [
  { to: '/caja', etiqueta: 'Punto de venta', icono: Wallet, permisos: ['caja.operar', 'ventas.cobrar'], palabrasClave: 'cobrar corte cierre arqueo' },
  { to: '/caja/boveda', etiqueta: 'Bóveda', icono: Landmark, permisos: ['boveda.ver'], palabrasClave: 'gastos renta caja fuerte banco retiros traspasos' },
  { to: '/caja/promociones', etiqueta: 'Promociones', icono: Tag, permisos: ['ventas.cobrar'], palabrasClave: 'descuentos paquetes ofertas cumpleaños' },
  { to: '/caja/importar', etiqueta: 'Importar apagón', icono: FileSpreadsheet, permisos: ['importacion.usar'], palabrasClave: 'excel importar apagón sin luz papel' },
];
SECCIONES_POR_MODULO.personal = SECCIONES_PERSONAL;

SECCIONES_POR_MODULO.inventario = [
  { to: '/inventario', etiqueta: 'Productos', icono: Boxes, permisos: ['inventario.ver'], palabrasClave: 'existencias stock sku precios' },
  { to: '/inventario/compras', etiqueta: 'Compras', icono: Receipt, permisos: ['inventario.ver'], palabrasClave: 'historial resurtir corregir gasto' },
  { to: '/inventario/proveedores', etiqueta: 'Proveedores', icono: Truck, permisos: ['inventario.ver'], palabrasClave: 'compras surtir' },
];

export const ICONO_VACIO = ClipboardList;
